export default __webpack_public_path__ + "static/media/0030.5c9ddec5.png";